import { If, UnderlineText } from 'aa_common/front-end/components'
import { isEmptyValue } from 'aa_common/front-end/helpers'
import { DEPRECIATION_METHOD_CODE } from 'common/constants'
import { getDMethod } from 'common/helpers'
import { getNs } from 'common/i18n-config'
import { LedgerSettingsItem } from 'common/models'
import Form from 'components/molecules/Form'

import { useGetAssetLedger } from '../hooks/use-get-asset-ledger'
import { useGetDepreciationRate } from '../hooks/use-get-depreciation-rate'
import { useIsFullImpairment } from '../hooks/use-is-full-impairment'

const { t, useNsReady } = getNs(['components/organisms/assets/asset-impairment', 'common'])
const { FormField } = Form

type DepreciationRateProps = {
  ledgerSetting?: LedgerSettingsItem
}

export const DepreciationRate = ({ ledgerSetting }: DepreciationRateProps) => {
  useNsReady()

  const assetLedger = useGetAssetLedger(ledgerSetting)
  const dMethodCode = getDMethod(assetLedger)
  const { isFullImpairment: disabled } = useIsFullImpairment()

  const shouldShow =
    !!dMethodCode &&
    [
      DEPRECIATION_METHOD_CODE.OLD_DECLINING_BALANCE,
      DEPRECIATION_METHOD_CODE.NEW_DECLINING_BALANCE_250,
      DEPRECIATION_METHOD_CODE.NEW_DECLINING_BALANCE_200,
    ].includes(dMethodCode)

  const depreciationRate = useGetDepreciationRate(shouldShow, assetLedger?.ledger_setting_id)

  return (
    <If condition={shouldShow}>
      <FormField title={t('depreciation_rate')} disabled={disabled}>
        <If condition={disabled}>
          <span className="disabled-content">ー</span>
        </If>
        <If condition={!disabled}>
          <UnderlineText>
            {isEmptyValue(depreciationRate) ? '' : `${Math.max(Number(depreciationRate), 0)}`}
          </UnderlineText>
        </If>
      </FormField>
    </If>
  )
}
